module.exports = __webpack_public_path__ + "img/slide_bck.c147ad52.jpg";